import client from './client';

const withCsrf = async (url, payload) => {
	await client.get('/sanctum/csrf-cookie');
	return client.post(url, payload);
};

const login = (loginPayload) => withCsrf('/login', loginPayload);

const register = (registerPayload) => withCsrf('/register', registerPayload);

const forgotPassword = ({ email }) => withCsrf('/forgot-password', { email });

const resetPassword = ({ token, email, password, password_confirmation }) =>
	withCsrf('/reset-password', { token, email, password, password_confirmation });

const logout = () => client.post('/logout');

const user = () => client.get('/api/user');

const storeEmailOfMobileUser = (email) => client.post('/api/mobile-users', { email });

const sendWAILinkOnMobileUserEmail = (email) => client.post('/api/mobile-users/email-link', { email });

export {
	login, logout, user, register, forgotPassword, resetPassword, storeEmailOfMobileUser, sendWAILinkOnMobileUserEmail
};
